import { render } from "./TeamActions.vue?vue&type=template&id=1c6143be"
import script from "./TeamActions.vue?vue&type=script&lang=js"
export * from "./TeamActions.vue?vue&type=script&lang=js"
script.render = render

export default script